import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface ISmartQCDeeplinkScriptData {
  whatsapp_text: string;
  phone_number?: string;
  link_url?: string;
}

export interface ISmartQCDeeplinkScriptResponse {
  status: boolean;
  message: string;
  data: ISmartQCDeeplinkScriptData;
}

export interface ISmartQCDeeplinkScriptParams {
  card_id: string;
  user_id?: string | null;
}

export const useSmartQCDeeplinkScriptAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [scriptData, setScriptData] = useState<ISmartQCDeeplinkScriptData | null>(null);

  const execute = useCallback(
    async ({
      card_id,
      user_id,
    }: ISmartQCDeeplinkScriptParams): Promise<{ status: boolean; data: ISmartQCDeeplinkScriptData | null }> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const endpoint = BOOKING_APIS?.SMART_QC_DEEPLINK_SCRIPT?.baseURL ?? "";
        const query = new URLSearchParams();
        query.append("card_id", card_id);
        if (user_id) query.append("user_id", user_id);

        const response = await axios
          .get(`${endpoint}?${query.toString()}`, {
            headers: { Authorization: `${accessToken}` },
          })
          .then((res: AxiosResponse<ISmartQCDeeplinkScriptResponse>) => {
            if (res.data?.status) {
              setScriptData(res.data.data);
              return { status: true, data: res.data.data };
            }
            setScriptData(null);
            return { status: false, data: null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);
            setScriptData(null);
            return { status: false, data: null };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        setScriptData(null);
        return { status: false, data: null };
      }
    },
    [configuration, dispatch, sendCurl, captureError],
  );

  return { execute, scriptData };
};
